import {Component, Input, OnInit} from '@angular/core';

import {IDailyScoreAvg, IWeeklyAvg,} from '../shared';

@Component({
  selector: 'awair-report-summary',
  templateUrl: './report-summary.component.html',
  styleUrls: ['./report-summary.component.scss']
})
export class ReportSummaryComponent implements OnInit {

  @Input() weeklyAvgList: IWeeklyAvg[];
  @Input() scoreCondition: string;
  @Input() dailyScoreAvgList: IDailyScoreAvg[];
  @Input() worstFactor: string;
  private _scoreWeeklyAvg: IWeeklyAvg;
  get scoreWeeklyAvg() {
    return this._scoreWeeklyAvg;
  }
  @Input()
  set scoreWeeklyAvg(value: IWeeklyAvg) {
    if (value != null) {
      this._scoreWeeklyAvg = {...value};

      this.isScoreIncreased = this._scoreWeeklyAvg.percentage.includes('+');
    }
  }

  isScoreIncreased: boolean;

  colorConditionMap = {
    'good': '#4FCC53',
    'fair': '#F8A91C',
    'poor': '#E63740'
  };

  constructor() { }

  ngOnInit() {
  }
}
